module.exports = __webpack_public_path__ + "static/media/BXBTC-BNB.fb3b41d6.svg";